// Credits charged per title update — shared by both Update Title pages.
// Keep in sync with backend TITLE_UPDATE_CREDIT_COST (single_gen/routes.py).
export const CREDIT_COST_PER_TITLE = 2;
